import { z } from "zod";
import { ZodDateString } from "../../zod-types/zod-date-string";

/**
 * A break is removed by the day it sits on rather than by its id: the caller is a reader clicking
 * the gap in a bar, which knows the date and has never been told the row's id.
 */
export const deleteTicketWorkExclusionQuerySchema = z.object({
	date: ZodDateString,
});

export type DeleteTicketWorkExclusionQuerySchema = z.infer<
	typeof deleteTicketWorkExclusionQuerySchema
>;
